import PosmoniLogsTable from './PosmoniLogsTable';
import React from 'react';
import {get} from 'lodash';
import moment from 'moment';

import ImageLoader from './ImageLoader';

class PosmoniImageLogs extends React.Component {

  rowComponent = (log) => {
    return (
      <div key={log.id} className='Table__row'>
        <div className='Table__col'>{moment(log.createdAt).format('YYYY-MM-DD HH:mm')}</div>
        <div className='Table__col'>{moment(log.updatedAt).format('YYYY-MM-DD HH:mm')}</div>
        <div className='Table__col'>{log.imageId}</div>
        <div className='Table__col'>
          <div className='ImageBorder ImageBorder--square'>
            <ImageLoader
              renderAsImg
              url={get(log, 'imageUrl')}
            />
          </div>
        </div>
        <div className='Table__col'>{log.status}</div>
        <div className='Table__col'>{log.mode}</div>
      </div>
    )
  }

  render() {
    return (
      <PosmoniLogsTable
        queryParams={this.props.query}
        modelName='user_validations'
        title='Lastest 10 Image AI checks'
        columns={['Created At', 'Updated At', 'Image ID', 'Image', 'Status', 'Mode']}
        rowComponent={this.rowComponent} />
    );
  }
}

export default PosmoniImageLogs
